module.exports = __webpack_public_path__ + "static/media/cards.a531d662.png";